import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const CustomerWebsiteLink = (props) => {
  return (
    <Link to={`//${props.data.website}`} target="_blank" rel="noopener noreferrer">{props.value}</Link>
  );
};

CustomerWebsiteLink.propTypes = {
  data: PropTypes.shape({
    website: PropTypes.string
  }).isRequired,
  value: PropTypes.node
};

export default CustomerWebsiteLink;
